import { useState, useEffect, useCallback } from 'react';
import { SubFamilyLookupItem } from '../types/costwand';
import { apiClient, ApiError } from '../api/apiClient.tsx';

interface UseSubFamilyLookupResult {
  subFamilies: SubFamilyLookupItem[];
  loading: boolean;
  error: string | null;
  fetchSubFamilies: () => Promise<void>;
}

export const useSubFamilyLookup = (): UseSubFamilyLookupResult => {
  const [subFamilies, setSubFamilies] = useState<SubFamilyLookupItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSubFamilies = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Changed to use allPages: true and expect { data: T[] }
      const response = await apiClient<{ data: SubFamilyLookupItem[] }>('/subfamilies', { allPages: true });
      setSubFamilies(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch subfamilies: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching subfamilies.');
      }
      setSubFamilies([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSubFamilies();
  }, [fetchSubFamilies]);

  return {
    subFamilies,
    loading,
    error,
    fetchSubFamilies,
  };
};